<script>
    /*
    	VerticalAvailableButton.svelte
    */

    import { onMount } from 'svelte';

    // TCARE components

    // SMUI components

    export let category;
    export let onClick;
    

    onMount(() => {
    })

</script>

<style>
    .available-cat-button {
        width: fit-content;
        min-width: 100px;
        margin-bottom: 10px;
        padding: 6px 20px 6px 20px;
        font-size: 13px;
        color: var(--tcui-primary);
        background-color: #F8F3F8;
        border: none;
        border-radius: 18px;
    }

    .available-cat-button:hover {
        background-color: #D3DDF9;
    }


    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<button class="available-cat-button" on:click={() => onClick(category)}>
    {category.label}
</button>
